module.exports = __webpack_public_path__ + "static/media/CognitiveModel.593e959f.svg";